<template>

  <div class="carouselOuter">

    <Carousel v-bind="carouselConfig">
      <Slide v-for="image in images" :key="image.id">
        <img :src="image.url" alt="image" />
      </Slide>

      <template #addons>
        <Navigation />
        <Pagination />
      </template>
    </Carousel>

  </div>

</template>
  
<script setup lang="ts">
    import 'vue3-carousel/dist/carousel.css';
    import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';

    const carouselConfig = {
      height: 190,
      gap: 5,
      autoplay: 4000,
      wrapAround: true,
      pauseAutoplayOnHover: true,
      breakpointMode: 'carousel', 
      breakpoints: {
        // 300px and up
        300: {
          itemsToShow: 1.4,
          snapAlign: 'center',
        },
        // 400px and up
        600: {
          itemsToShow: 2.4,
          snapAlign: 'center',
        },
        // 500px and up
        900: {
          itemsToShow: 3.4,
          snapAlign: 'center',
        },
        // 800px and up
        1200: {
          itemsToShow: 4.4,
          snapAlign: 'center',
        },
          1450: {
          itemsToShow: 5.4,
          snapAlign: 'center',
        },
          1650: {
          itemsToShow: 6.4,
          snapAlign: 'center',
        }
      }
  }

    const images = Array.from({ length: 14 }, (_, index) => ({
        id: index + 1,
        url: require('../../assets/carousel/' + (index+1) + '.jpg'),
      }))

</script>

<style>

.carouselOuter {
  margin-top: 20px;
  margin-bottom: 40px;
}

.carousel {
    --vc-pgn-background-color: rgba(255, 255, 255, 0.7);
    --vc-pgn-active-color: rgba(255, 255, 255, 1);
    --vc-nav-background: rgba(255, 255, 255, 0.7);
    --vc-nav-border-radius: 100%;
  }

  .carousel img {
  border-radius: 8px;
  height: 190px;
  object-fit: cover;
}

</style>
